module.exports = __webpack_public_path__ + "assets/img/18_1849_big.17ed134c.jpg";